/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function PauseIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M13 11v18h3V11zm-3 0a3 3 0 0 1 3-3h3c1.625 0 3 1.375 3 3v18a3 3 0 0 1-3 3h-3c-1.687 0-3-1.312-3-3zm14 0v18h3V11zm-3 0a3 3 0 0 1 3-3h3c1.625 0 3 1.375 3 3v18a3 3 0 0 1-3 3h-3c-1.687 0-3-1.312-3-3z"/>}
        </IconWrapper>);
}
